// @ts-nocheck
(function () {
  var VARIANT_CHANGE_EVENT = 'product:variant-change';

  function defineCustomElements() {
    if (!window.customElements) return;

    if (!customElements.get('product-price')) {
      customElements.define(
        'product-price',
        class ProductPriceElement extends HTMLElement {
          connectedCallback() {
            this._onVariantChange =
              this._onVariantChange || this.onVariantChange.bind(this);
            document.addEventListener(
              VARIANT_CHANGE_EVENT,
              this._onVariantChange
            );
          }

          disconnectedCallback() {
            if (this._onVariantChange) {
              document.removeEventListener(
                VARIANT_CHANGE_EVENT,
                this._onVariantChange
              );
            }
          }

          onVariantChange(event) {
            if (!event || !event.detail) return;
            var productId = this.getAttribute('data-product-id');
            if (
              !productId ||
              String(productId) !== String(event.detail.productId)
            )
              return;

            var priceData = event.detail.price;
            if (!priceData) return;

            // Preserve markup and update only the relevant parts (current + compare)
            // instead of replacing the whole component content.
            setPriceElementText(this, priceData);
          }
        }
      );
    }

    if (!customElements.get('product-variants')) {
      customElements.define(
        'product-variants',
        class ProductVariantsElement extends HTMLElement {}
      );
    }
  }

  function parseJson(root, selector) {
    var node = root.querySelector(selector);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      return null;
    }
  }

  function setPriceElementText(priceElement, priceData) {
    if (!priceElement || !priceData) return;

    var currentPrice =
      typeof priceData === 'object' ? priceData.price : priceData;
    var comparePrice =
      typeof priceData === 'object' ? priceData.compare_at_price : null;

    var currentValue =
      typeof priceData === 'object' ? priceData.price_value : null;
    var compareValue =
      typeof priceData === 'object' ? priceData.compare_at_price_value : null;

    var showCompare = false;
    if (
      compareValue != null &&
      currentValue != null &&
      Number(compareValue) > Number(currentValue)
    ) {
      showCompare = true;
    } else if (comparePrice && comparePrice !== currentPrice) {
      // Fallback for legacy string-only price data.
      showCompare = true;
    }

    var currentEl = priceElement.querySelector('.product-price__current');
    if (currentEl) {
      currentEl.textContent = currentPrice;
    } else {
      priceElement.textContent = currentPrice;
    }

    var compareEl = priceElement.querySelector('.product-price__compare');
    if (compareEl) {
      if (showCompare) {
        compareEl.textContent = comparePrice;
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    } else if (showCompare) {
      var span = document.createElement('span');
      span.className = 'product-price__compare';
      span.textContent = comparePrice;
      if (currentEl) {
        currentEl.parentNode.insertBefore(span, currentEl);
      } else {
        priceElement.insertBefore(span, priceElement.firstChild);
      }
    }
  }

  function getSelectedValues(root) {
    var selectedValues = [];
    root
      .querySelectorAll('.product-variants__option')
      .forEach(function (option) {
        var optionIndex = Number(option.getAttribute('data-option-index'));
        var activeButton = option.querySelector(
          '.product-variant-button.is-active'
        );
        if (!activeButton) return;
        selectedValues[optionIndex] =
          activeButton.getAttribute('data-option-value') || '';
      });
    return selectedValues;
  }

  function findVariantBySelectedOptions(
    variants,
    selectedValues,
    onlyAvailable
  ) {
    return variants.find(function (variant) {
      if (!Array.isArray(variant.options)) return false;
      if (onlyAvailable && !variant.available) return false;
      return variant.options.every(function (optionValue, index) {
        return selectedValues[index] === optionValue;
      });
    });
  }

  function applyVariantSelection(root, variant) {
    if (!variant || !Array.isArray(variant.options)) return;

    root
      .querySelectorAll('.product-variants__option')
      .forEach(function (option) {
        var optionIndex = Number(option.getAttribute('data-option-index'));
        var selectedValue = variant.options[optionIndex];

        option
          .querySelectorAll('.product-variant-button')
          .forEach(function (button) {
            var isActive =
              (button.getAttribute('data-option-value') || '') ===
              selectedValue;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
      });
  }

  function updateButtonAvailability(root, variants) {
    var selectedValues = getSelectedValues(root);

    root
      .querySelectorAll('.product-variants__option')
      .forEach(function (option) {
        var optionIndex = Number(option.getAttribute('data-option-index'));

        option
          .querySelectorAll('.product-variant-button')
          .forEach(function (button) {
            var optionValue = button.getAttribute('data-option-value') || '';

            var isAvailable = variants.some(function (variant) {
              if (!variant.available || !Array.isArray(variant.options))
                return false;
              if (variant.options[optionIndex] !== optionValue) return false;

              return variant.options.every(
                function (variantOptionValue, index) {
                  if (index === optionIndex) return true;

                  var selectedValue = selectedValues[index];
                  if (!selectedValue) return true;

                  return variantOptionValue === selectedValue;
                }
              );
            });

            button.classList.toggle('is-disabled', !isAvailable);
            if (isAvailable) {
              button.removeAttribute('disabled');
              button.removeAttribute('aria-disabled');
            } else {
              button.setAttribute('disabled', '');
              button.setAttribute('aria-disabled', 'true');
            }
          });
      });
  }

  function updateQuickViewPrice(root, variantId, pricesById) {
    if (!variantId || !pricesById) return;
    var quickViewRoot = root.closest('.quick-view-template');
    if (!quickViewRoot) return;

    var priceElement = quickViewRoot.querySelector('.quick-view-price');
    if (!priceElement) return;

    var variantPrice = pricesById[String(variantId)];
    if (variantPrice) {
      setPriceElementText(priceElement, variantPrice);
    }
  }

  function updateInlinePrice(root, variantId, pricesById) {
    if (!variantId || !pricesById) return;

    var priceElement = root.querySelector('.product-variants__price-value');
    if (!priceElement) return;

    var variantPrice = pricesById[String(variantId)];
    if (variantPrice) {
      setPriceElementText(priceElement, variantPrice);
    }
  }

  function updateLinkedBlockPrices(root, variantId, pricesById) {
    if (!variantId || !pricesById) return;

    var variantPrice = pricesById[String(variantId)];
    if (!variantPrice) return;

    var productId = root.getAttribute('data-product-id');
    var form = root.closest('form');
    var scope = form || root.parentElement || document;
    var priceElements = scope.querySelectorAll(
      'product-price[data-product-id], [data-product-price-product-id], #recently-viewed-product-data[data-product-price]'
    );

    priceElements.forEach(function (priceElement) {
      var targetProductId =
        priceElement.getAttribute('data-product-id') ||
        priceElement.getAttribute('data-product-price-product-id');
      if (targetProductId && productId && targetProductId !== productId) {
        return;
      }

      setPriceElementText(priceElement, variantPrice);
    });
  }

  function findGallery(root) {
    var scope =
      root.closest('.quick-view-template') ||
      root.closest('.product-section') ||
      root.closest('section') ||
      document;
    var selectors = [
      '.quick-view-images [data-image-slider]',
      '.quick-view-images .image-slider',
      '.product-section__gallery [data-image-slider]',
      '.product-section__gallery [data-product-media-gallery]',
      '.product__gallery [data-image-slider]',
      '.product__gallery [data-product-media-gallery]',
      '.product__gallery .image-slider',
      '[data-image-slider]',
      '.image-slider',
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var gallery = scope.querySelector(selectors[i]);
      if (gallery) return gallery;
    }

    return null;
  }

  function findGallerySlideIndex(gallery, mediaData) {
    if (!gallery || !mediaData) return -1;

    var slides = gallery.querySelectorAll(
      '.image-slider__slide, .swiper-slide'
    );
    if (!slides.length) return -1;

    if (mediaData.image_id != null) {
      for (var i = 0; i < slides.length; i += 1) {
        if (
          String(slides[i].getAttribute('data-image-id')) ===
          String(mediaData.image_id)
        ) {
          return i;
        }
      }
    }

    if (mediaData.image_position != null) {
      for (var j = 0; j < slides.length; j += 1) {
        if (
          String(slides[j].getAttribute('data-image-position')) ===
          String(mediaData.image_position)
        ) {
          return j;
        }
      }
    }

    return -1;
  }

  function slideGalleryToIndex(gallery, targetIndex, attempt) {
    if (!gallery || targetIndex < 0) return;

    var currentAttempt = attempt || 0;
    var swiper = gallery.swiperInstance;

    if (swiper) {
      if (typeof swiper.slideToLoop === 'function') {
        swiper.slideToLoop(targetIndex);
        return;
      }

      if (typeof swiper.slideTo === 'function') {
        swiper.slideTo(targetIndex);
        return;
      }
    }

    if (currentAttempt >= 5) return;

    window.setTimeout(function () {
      slideGalleryToIndex(gallery, targetIndex, currentAttempt + 1);
    }, 60);
  }

  function updateGalleryImage(root, variantId, mediaById) {
    if (!variantId || !mediaById) return;

    var mediaData = mediaById[String(variantId)];
    if (!mediaData) return;

    var gallery = findGallery(root);
    if (!gallery) return;

    var targetIndex = findGallerySlideIndex(gallery, mediaData);
    if (targetIndex < 0) return;

    slideGalleryToIndex(gallery, targetIndex, 0);
  }

  function getPrimaryVariantInput(form) {
    if (!form) return null;
    return form.querySelector(
      'product-variants:not([data-variant-sync-only]) .product-variants__input[name="id"], .product-variants:not([data-variant-sync-only]) .product-variants__input[name="id"]'
    );
  }

  function syncSiblingVariantRoots(sourceRoot, selectedVariant, variants) {
    if (!selectedVariant || !selectedVariant.id) return;

    var form = sourceRoot.closest('form');
    if (!form) return;

    var productId = sourceRoot.getAttribute('data-product-id');
    if (!productId) return;

    var primaryInput = getPrimaryVariantInput(form);
    if (primaryInput) {
      primaryInput.value = String(selectedVariant.id);
    }

    form
      .querySelectorAll(
        'product-variants[data-product-id="' +
          productId +
          '"], .product-variants[data-product-id="' +
          productId +
          '"]'
      )
      .forEach(function (sibling) {
        if (sibling === sourceRoot) return;

        sibling._variantSyncing = true;
        applyVariantSelection(sibling, selectedVariant);
        updateButtonAvailability(sibling, variants);

        var siblingInput = sibling.querySelector('.product-variants__input');
        if (siblingInput) {
          siblingInput.value = String(selectedVariant.id);
        }

        updateUnavailableStatus(sibling, selectedVariant);
        sibling._variantSyncing = false;
      });
  }

  function getVariantQuantityState(variant, quantityLimitsById) {
    if (!variant || !variant.id) {
      return {
        max: null,
        message: '',
      };
    }

    var variantId = String(variant.id);
    var quantityLimit = quantityLimitsById && quantityLimitsById[variantId];

    if (quantityLimit && quantityLimit.max != null) {
      var explicitMax = Number(quantityLimit.max);
      if (!Number.isNaN(explicitMax)) {
        return {
          max: Math.max(1, explicitMax),
          message: quantityLimit.message || '',
        };
      }
    }

    if (!variant.inventory_management) {
      return {
        max: null,
        message: '',
      };
    }

    if (variant.inventory_policy === 'continue') {
      return {
        max: null,
        message: '',
      };
    }

    var inventoryQuantity = Number(variant.inventory_quantity);
    if (Number.isNaN(inventoryQuantity)) {
      return {
        max: null,
        message: '',
      };
    }

    return {
      max: Math.max(1, inventoryQuantity),
      message: '',
    };
  }

  function emitVariantChange(
    root,
    selectedVariant,
    pricesById,
    quantityLimitsById
  ) {
    if (!selectedVariant || !selectedVariant.id || !pricesById) return;

    var variantId = selectedVariant.id;
    if (!variantId || !pricesById) return;

    var variantPrice = pricesById[String(variantId)];
    if (!variantPrice) return;

    var quantityState = getVariantQuantityState(
      selectedVariant,
      quantityLimitsById
    );
    var productId = root.getAttribute('data-product-id');
    var detail = {
      productId: productId,
      variantId: String(variantId),
      price: variantPrice,
      quantityMax: quantityState.max,
      quantityMaxMessage: quantityState.message,
    };

    root.dispatchEvent(
      new CustomEvent(VARIANT_CHANGE_EVENT, {
        bubbles: true,
        detail: detail,
      })
    );
  }

  function updateUnavailableStatus(root, selectedVariant) {
    var statusElement = root.querySelector('.product-variants__status');
    if (!statusElement) return;

    if (selectedVariant && selectedVariant.available) {
      statusElement.setAttribute('hidden', 'hidden');
      return null;
    }

    statusElement.textContent =
      statusElement.getAttribute('data-unavailable-message') || '';
    statusElement.removeAttribute('hidden');
  }

  function resolveSelectedVariant(root, variants, changedOptionIndex) {
    var selectedValues = getSelectedValues(root);
    var exactVariant = findVariantBySelectedOptions(
      variants,
      selectedValues,
      false
    );
    if (exactVariant && exactVariant.available) {
      return exactVariant;
    }

    if (
      typeof changedOptionIndex === 'number' &&
      !Number.isNaN(changedOptionIndex)
    ) {
      var changedValue = selectedValues[changedOptionIndex];
      var variantMatchingChangedOption = variants.find(function (variant) {
        return (
          variant.available &&
          Array.isArray(variant.options) &&
          variant.options[changedOptionIndex] === changedValue
        );
      });

      if (variantMatchingChangedOption) {
        applyVariantSelection(root, variantMatchingChangedOption);
        return variantMatchingChangedOption;
      }
    }

    var firstAvailableVariant = variants.find(function (variant) {
      return variant.available;
    });

    if (firstAvailableVariant) {
      applyVariantSelection(root, firstAvailableVariant);
      return firstAvailableVariant;
    }

    return exactVariant || null;
  }

  function updateVariantState(
    root,
    variants,
    pricesById,
    mediaById,
    quantityLimitsById,
    changedOptionIndex
  ) {
    if (!Array.isArray(variants) || !variants.length) return;
    if (root._variantSyncing) return;

    var selectedVariant = resolveSelectedVariant(
      root,
      variants,
      changedOptionIndex
    );
    updateButtonAvailability(root, variants);

    var input = root.querySelector('.product-variants__input');
    if (selectedVariant && selectedVariant.id && input) {
      input.value = String(selectedVariant.id);
      updateGalleryImage(root, selectedVariant.id, mediaById);
      updateQuickViewPrice(root, selectedVariant.id, pricesById);
      updateInlinePrice(root, selectedVariant.id, pricesById);
      updateLinkedBlockPrices(root, selectedVariant.id, pricesById);
      syncSiblingVariantRoots(root, selectedVariant, variants);
      emitVariantChange(root, selectedVariant, pricesById, quantityLimitsById);
    }

    updateUnavailableStatus(root, selectedVariant);
  }

  function initializeRoot(root) {
    if (!root) return;

    var variants = parseJson(root, '.product-variants__variants-json') || [];
    var pricesById = parseJson(root, '.product-variants__prices-json') || {};
    var mediaById = parseJson(root, '.product-variants__media-json') || {};
    var quantityLimitsById =
      parseJson(root, '.product-variants__quantity-limits-json') || {};

    updateVariantState(
      root,
      variants,
      pricesById,
      mediaById,
      quantityLimitsById
    );
  }

  function initializeAll() {
    defineCustomElements();

    document
      .querySelectorAll('product-variants, .product-variants')
      .forEach(function (root) {
        initializeRoot(root);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }

  document.addEventListener('dialog:open', function () {
    window.setTimeout(initializeAll, 0);
  });

  document.addEventListener('click', function (event) {
    var btn =
      event.target.closest && event.target.closest('.product-variant-button');
    if (!btn) return;
    if (btn.disabled || btn.classList.contains('is-disabled')) return;

    var root = btn.closest('product-variants, .product-variants');
    if (!root) return;

    var variants = parseJson(root, '.product-variants__variants-json') || [];
    var pricesById = parseJson(root, '.product-variants__prices-json') || {};
    var mediaById = parseJson(root, '.product-variants__media-json') || {};
    var quantityLimitsById =
      parseJson(root, '.product-variants__quantity-limits-json') || {};

    var optionGroup = btn.closest('.product-variants__option');
    var changedOptionIndex = optionGroup
      ? Number(optionGroup.getAttribute('data-option-index'))
      : undefined;

    var group = btn.parentElement;
    if (group) {
      group.querySelectorAll('.product-variant-button').forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
    }

    updateVariantState(
      root,
      variants,
      pricesById,
      mediaById,
      quantityLimitsById,
      changedOptionIndex
    );
  });
})();
